<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>検索結果</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="table-responsive" style="border: solid 1px rgba(0, 0, 0, 0.12); margin-bottom: 20px">
            <table id="searchResult" mat-table multiTemplateDataRows [dataSource]="dataSource" matSort #sort1="matSort"
                class="mat-elevation-z8" style="width: 100%; min-width: 1100px; border: solid 1px rgba(0, 0, 0, 0.12);">
                <ng-container matColumnDef="scheduledDate">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header
                        style="min-width:100px;width:100px; padding-right:0px">予定日時
                    </th>
                    <td mat-cell *matCellDef="let row">{{ (row.workScddt | dateString) + '\n' +
                        (row.scheduledworkTimezoneCode.aname ?? '') }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="rcvmnyConect.rcvmnyConectFlg">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header
                        style="min-width:44px;width:44px;">入金連絡
                    </th>
                    <td mat-cell class="mat-cell-center" *matCellDef="let row">{{ row.rcvmnyConect.rcvmnyConectFlg ? '〇'
                        : ''}}</td>
                </ng-container>

                <ng-container matColumnDef="autolockUmuFlg">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header
                        style="min-width:72px;width:72px;">オート<br>ロック
                    </th>
                    <td mat-cell class="table-cell-type-button" *matCellDef="let row">
                        <button (click)="onClickAutoLockButton(row)" type="button" [disabled]="false"
                            style="border-radius: 5px; border-color: blue; color: blue; margin-top: 10px;"
                            [style.background-color]="getAutolockBgColor(row.autolockUmuFlg.codeValue)"
                            mat-stroked-buton class="btn" id='autolockUmuFlg'>{{row.autolockUmuFlg.aname}}</button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="supplystopresumptionWorkClscode.aname">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header
                        style="min-width:110px;width:110px;">作業種別
                    </th>
                    <td mat-cell class="table-cell-type-button" *matCellDef="let row">
                        <button (click)="onClickOperation(row)" type="button" [disabled]="false"
                            style="border-radius: 5px; border-color: blue; color: blue; margin-top: 10px;"
                            mat-stroked-buton class="btn"
                            id='sagyoSyubetsu'>{{getSagyoSyubetsuLabel(row.supplystopresumptionWorkClscode)}}</button>
                    </td>
                </ng-container>
                <ng-container matColumnDef="supplystopResumeSts.aname">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header
                        style="min-width:90px;width:90px;">状態
                    </th>
                    <td mat-cell class="mat-cell-center" style="padding-right: 15px;" *matCellDef="let row">{{
                        row.supplystopResumeSts.aname }}</td>
                </ng-container>

                <ng-container matColumnDef="energyClscode.aname">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header
                        style="min-width:46px;width:46px;">エネ種
                    </th>
                    <td mat-cell class="mat-cell-center" *matCellDef="let row">{{ row.energyClscode.aname }}</td>
                </ng-container>
                <ng-container matColumnDef="visitormei">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header
                        style="min-width:140px;">お客さま名<br>（お客さまカナ）
                    </th>
                    <td mat-cell *matCellDef="let row">{{ (row.visitormei ?? '') + '\n' +
                        (row.visitnamekana ? ('（' + row.visitnamekana ) + '）' : '') }}</td>
                </ng-container>
                <ng-container matColumnDef="supplydestinationAddr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:280px;"
                        class="border-bottom-double under-col">住所</th>
                    <td mat-cell class="under-col" *matCellDef="let row"><mat-icon (click)="onClickMapIcon(row)"
                            style="color: blue;" id="place">
                            place</mat-icon>{{ row.supplydestinationAddr }}</td>
                </ng-container>
                <ng-container matColumnDef="sougouDivcd.aname">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header
                        style="min-width:42px;width:42px;">被<br>総合
                    </th>
                    <td class="mat-cell-center" mat-cell *matCellDef="let row">{{ row.sougouDivcd.codeValue == '2' ? '〇'
                        : '' }}</td>
                </ng-container>
                <ng-container matColumnDef="meterDiscrm.aname">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header
                        style="min-width:55px;width:55px;">親／子
                    </th>
                    <td class="mat-cell-center" mat-cell *matCellDef="let row">{{ row.meterDiscrm.aname }}</td>
                </ng-container>
                <ng-container matColumnDef="payCtrNo">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width:120px;width:120px;">支払契約番号</th>
                    <td mat-cell *matCellDef="let row">{{ row.payCtrNo }}</td>
                </ng-container>
                <ng-container matColumnDef="sumaddMatomecode.aname">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width:65px;width:65px;padding-right:5px">合算／まとめ</th>
                    <td class="mat-cell-center" mat-cell *matCellDef="let row">{{ row.sumaddMatomecode.aname }}</td>
                </ng-container>
                <ng-container matColumnDef="custmReferral">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width:55px;width:55px;">お客さま<br>照会</th>
                    <td mat-cell class="table-cell-type-button" *matCellDef="let row" id="custmReferral">
                        <button (click)="onClickShokai(row)" type="button" [disabled]="false" 
                            style="border-radius: 5px; border-color: blue; color: blue; margin-top: 10px;"
                            mat-stroked-buton class="btn" id='syokai'>{{'お客さま\n照会'}}</button>
                    </td>
                </ng-container>
                <tr mat-header-row class="border-bottom-double" *matHeaderRowDef="displayedColumnsCol; sticky: true">
                </tr>
                <tr mat-row class="clickable-mat-row" *matRowDef="let row; columns: displayedColumnsCol">
                </tr>
            </table>
        </div>
    </mat-card-content>
</mat-card>